export interface IPassenger {
    firstName: string;
    lastName: string;
    iban: string | null;
    email: string;
}

export type TDocumentEncoding = "identity" | "gzip";
export interface IClaimDocument {
    fileName: string;
    documentType: string;
    mimeType: string;
    fileSize: string;
    uploadedAt: string;
    contentBlob: Blob;
    contentEncoding: TDocumentEncoding;
    originalMimeType: string;
}

export interface IClaimFlight {
    originalFlightId: string;
    originalFlightDepartureAt: string;
    originalFlightArrivalAt:   string;
    originalFlightOrigin: string;
    originalFlightDestination: string;
    originalFlightFlightNumber: string;
    originalFlightIataCode:   string;
    sameAsOriginalFlight: boolean;
    actualFlightId: string;
    actualFlightDepartureAt: string;
    actualFlightArrivalAt: string;
    actualFlightOrigin: string;
    actualFlightDestination: string;
    actualFlightFlightNumber: string;
    actualFlightIataCode: string;
}

export interface IClaim {
    claimId: string;
    bookingReference: string;
    claimStatus: ClaimStatuses;
    compensationAmount: number;
    compensationFee: number;
    notes: string | null;
    passengers: Array<IPassenger>;
    flights: Array<IClaimFlight>;
    historyEntries: Array<IClaimHistory>;
    companyId: string;
    createdBy: string;
    isActive:  boolean;
    createdAt: string;
}

export enum ClaimStatuses {
    DRAFT = -1,
    READY,
    SUBMITTED,
    NEGATIVE_RESPONSE,
    READY_FOR_APPEAL,
    APPEAL_SUBMITTED,
    NEGATIVE_AFTER_APPEAL,
    WAITING_PAYMENT,
    PAYMENT_CONFIRMED,
    PAID,
    PENDING_CONTRACT,
    PENDING_DOCUMENTS
}


export interface IClaimHistory {
    claimHistoryId: string;
    claimId: string;
    changedBy: string;
    fieldName: string;
    oldValue: string | number | null;
    newValue: string | number | null;
    changeType: string;
    changedAt: string;
}

